// extracted by mini-css-extract-plugin
module.exports =  {"select":"ZjWOgSxvjwNS8sBO5Rvg"};